import { render, staticRenderFns } from "./AddressAppendsChip.vue?vue&type=template&id=1b697dce&"
import script from "./AddressAppendsChip.vue?vue&type=script&lang=js&"
export * from "./AddressAppendsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports